export type HistoryTabGroup = 'Perpetual' | 'Spot' | 'Transaction';

export interface HistoryTab {
  group: HistoryTabGroup;
  label: string;
  value: string;
  hideOnSpotOnly?: boolean;
}

export const PerpetualHistoryTabList: HistoryTab[] = [
  { group: 'Perpetual', label: 'Position', value: '/history/perpetual/position' },
  { group: 'Perpetual', label: 'P&L', value: '/history/perpetual/pnl' },
  { group: 'Perpetual', label: 'Funding', value: '/history/perpetual/funding' },
  { group: 'Perpetual', label: 'Trade', value: '/history/perpetual/trade' },
  { group: 'Perpetual', label: 'Profit boost', value: '/history/perpetual/profit-boost' },
  { group: 'Perpetual', label: 'Airdrop', value: '/history/perpetual/airdrop' },
];

export const SpotHistoryTabList: HistoryTab[] = [
  { group: 'Spot', label: 'P&L', value: '/history/spot/pnl' },
  { group: 'Spot', label: 'Trade', value: '/history/spot/trade' },
];

export const TransactionHistoryTabList: HistoryTab[] = [
  { group: 'Transaction', label: 'Earn', value: '/history/transaction/earn', hideOnSpotOnly: true },
  {
    group: 'Transaction',
    label: 'Launchpool reward',
    value: '/history/transaction/launchpool-reward',
    hideOnSpotOnly: true,
  },
  { group: 'Transaction', label: 'Deposit', value: '/history/transaction/deposit' },
  { group: 'Transaction', label: 'Withdrawal', value: '/history/transaction/withdrawal' },
  { group: 'Transaction', label: 'Conversion', value: '/history/transaction/conversion' },
  {
    group: 'Transaction',
    label: 'Referral & Affiliate',
    value: '/history/transaction/referral-and-affiliate',
    hideOnSpotOnly: true,
  },
];

export const HistoryTabList = [
  { label: 'Perpetual', value: 'Perpetual', hideOnSpotOnly: true },
  { label: 'Spot', value: 'Spot' },
  { label: 'Transaction', value: 'Transaction' },
];

export const getTabList = (historyTabGroup: HistoryTabGroup, isSpotOnly: boolean) => {
  const tabList = (() => {
    switch (historyTabGroup) {
      case 'Perpetual':
        return PerpetualHistoryTabList;
      case 'Spot':
        return SpotHistoryTabList;
      case 'Transaction':
        return TransactionHistoryTabList;
      default:
        return [];
    }
  })();

  return isSpotOnly ? tabList.filter((tabItem) => !tabItem.hideOnSpotOnly) : tabList;
};

export const getHistoryTabList = (isSpotOnly: boolean): { label: string; value: HistoryTabGroup }[] => {
  return [
    ...(isSpotOnly ? [] : ([{ label: 'Perpetual', value: 'Perpetual' }] as const)),
    { label: 'Spot', value: 'Spot' },
    { label: 'Transaction', value: 'Transaction' },
  ];
};
